<div class="info__container" >
    <button type="button" class="overlay" (click)="onClickClose()" tabindex="0"></button>
    <div class="info__wrap">
        <img [src]="data.image" alt="" class="info__image">
        <div class="info__title">{{data.title | translate}}</div>
        <div class="info__description">{{data.description | translate}}</div>
        <div class="wrap__button">
            @for (item of buttons; track $index) {
               @if (item?.text) {
                <button class="button"
                [ngClass]="item.isBgRed ? 'bg-[#ed0226] text-[#FFFFFF]':'text-[#ed0226] bg-[#FFFFFF]'"
                (click)="onClickButton(item.url)">{{item.text | translate}}</button>
               }
            }
        </div>
    </div>
</div>